import {createPortal} from "react-dom";
import styles from "./FinishEventModal.module.scss";
import React from "react";
import { API_BASE } from "../../../../config/api";

interface FinishEventModalProps {
    id: number;
    token: string | undefined;
    setIsFinishModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FinishEventModal: React.FC<FinishEventModalProps> = ({ setIsFinishModalOpen, id, token }) => {
    const onClose = () => {
        setIsFinishModalOpen(false);
    };

    const onFinish = async () => {
        try {
            const response = await fetch(`${API_BASE}/events/${id}/terminate/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.detail || 'Unknown error');
            }

            window.location.reload();
        } catch (error : any) {
            alert(error.message);
        }
    };


    return createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal}>
                <h1 className={styles.modalTitle}>Завершить событие?</h1>
                <p className={styles.modalText}>Продажа билетов остановится и мероприятие больше не будет доступно пользователям</p>
                <div className={styles.btnWrapper}>
                    <button className={styles.btnOutline}
                    onClick={onClose}>Назад</button>
                    <button className={styles.btnNormal}
                    onClick={onFinish}>Завершить</button>
                </div>
            </div>
        </div>, document.body
    )
}